module.exports = __webpack_public_path__ + "img/LT112043124.362875e2.png";